import React, { useState } from 'react'
import { Form, Icon, Input, Modal, Row, Select, Upload, Radio, Col, Button } from 'antd'
import { EQUIPMENT_CATEGORY, HERO_TYPE, HERO_TYPE_MESSAGE } from '../../../../utils/constants'

const EquipmentForm = (props) => {
  const { visible, onCancel, formData  ,formDataSubEquipment ,formDataCategory ,formDataSeller} = props

  return (
    <Modal
      visible={visible}
      title='รายละเอียดเครื่องจักรอุปกรณ์'
      footer={null}
      onCancel={onCancel}
    >
      <Row type="flex" gutter={8}>
        <Col>
          <h4>ชื่อเครื่องจักรอุปกรณ์ : </h4>
        </Col>
        <Col>
          <div>{formData.name}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <Col>
          <h4>รายละเอียด : </h4>
        </Col>
        <Col>
          <div>{formData.detail}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <Col>
          <h4>ราคา : </h4>
        </Col>
        <Col>
          <div>{formData.price}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <Col>
          <h4>หมวดหมู่หลัก : </h4>
        </Col>
        <Col>
        <div>{formDataCategory.name}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <Col>
          <h4>หมวดหมู่ย่อย : </h4>
        </Col>
        <Col>
          <div>{formDataSubEquipment.name}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <Col>
          <h4>ผู้ขาย : </h4>
        </Col>
        <Col>
          <div>{formDataSeller.name}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8} justify="end">
        <Col>
          <Button onClick={() => onCancel()}>ปิด</Button>
        </Col>
      </Row>
    </Modal>
  )
}

const WrappedEquipmentForm = Form.create({
  name: 'EquipmentForm'
})(EquipmentForm)
export default (WrappedEquipmentForm)
